import { FC } from "react";

import { useFullUserProfileContext } from "Bands/contexts";
import { copy } from "shared/assets";
import { ContactTeaser, Loader, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { GridContainer } from "shared/styles";
import { useFetchingContactDetails } from "Bands/utils";

const contactCopy = copy.userEmergencyContact;

export const EmergencyContacts: FC = () => {
  const { emergencyContacts } = useFullUserProfileContext();

  const { fetchingEmergencyContacts } = useFetchingContactDetails();

  if (fetchingEmergencyContacts) return <Loader />;
  if (!emergencyContacts?.length) return null;

  return (
    <Spacer size="s">
      <Title title={contactCopy.title} asComponent="h3" size="s" />
      <GridContainer>
        {emergencyContacts?.map(contact => (
          <ContactTeaser {...contact} key={contact.id} phone={contact.phoneNumber} />
        ))}
      </GridContainer>
    </Spacer>
  );
};
